import { useAuth } from '@/shared/auth/auth-context';
import { useEventConfig } from '@/shared/config/event-config-context';
import { displayNameOf } from '@/shared/lib/person-name';
import { Button } from '@/shared/ui/Button';
import { BrandMark } from '@/shared/ui/BrandMark';
import { SignOutIcon } from '@/shared/ui/icons';

/** Barra superior fixa: identidade do painel à esquerda, operador logado à direita. */
export function AppHeader() {
  const { session, signOut } = useAuth();
  const { title } = useEventConfig();
  const email = session?.email ?? '';
  const name = session ? displayNameOf(session) : '';

  return (
    <header className="sticky top-0 z-30 border-b border-line bg-surface/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[85rem] items-center justify-between gap-4 px-4 sm:px-6">
        {/* O título vem da parametrização do evento; a edição não existe no
            documento, então o cabeçalho do painel fica em uma linha. */}
        <BrandMark title={title} subtitle="" />

        <div className="flex items-center gap-3">
          {/* Nome em cima, e-mail embaixo, os dois alinhados pela esquerda: é o
              e-mail que define a largura do bloco, e centralizar o nome sobre ele
              deixava a borda esquerda irregular. Sem pílula nem avatar: quem está
              logado é informação de apoio, e a cápsula competia com os controles
              ao lado. */}
          <div className="hidden max-w-[16rem] flex-col items-start leading-tight sm:flex">
            <span className="max-w-full truncate text-[0.8125rem] font-medium text-ink">{name}</span>
            <span className="max-w-full truncate text-[0.75rem] text-ink-muted">{email}</span>
          </div>

          <Button variant="ghost" size="sm" onClick={signOut}>
            <SignOutIcon className="size-4" />
            <span className="hidden sm:inline">Sair</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
